(function( $, document ) {
	var iconicwp_plugin = {
		/**
		 * Run on doc ready.
		 */
		on_ready: function() {
			iconicwp_plugin.support_form.init();
		},

		helpers: {
			/**
			 * Run function after delay.
			 */
			delay: {
				/**
				 * Timer.
				 */
				timer: 0,
				/**
				 * Wait.
				 *
				 * @param callback
				 * @param ms
				 */
				wait: function( callback, ms ) {
					clearTimeout( iconicwp_plugin.helpers.delay.timer );
					iconicwp_plugin.helpers.delay.timer = setTimeout( callback, ms );
				}
			},

			/**
			 * Make HTML link list element.
			 *
			 * @param array
			 */
			make_link_list: function( array ) {
				// Create the list element:
				var $list = $( '<ul />' );

				for ( var i = 0; i < array.length; i ++ ) {
					// Create the list item:
					var $item = $( '<li />' ),
						$anchor = $( '<a />' );

					// Set anchor data:
					$anchor.attr( 'href', array[ i ].url ).attr( 'target', '_blank' );

					// Set its contents:
					$anchor.text( array[ i ].text );

					// Add anchor to list item:
					$item.append( $anchor );

					// Add it to the list:
					$list.append( $item );
				}

				// Finally, return the constructed list:
				return $list;
			},

			spinner: {
				/**
				 * Spinner class.
				 */
				class: 'gform_ajax_spinner',

				/**
				 * Template.
				 */
				tpl: '<img class="gform_ajax_spinner" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="" />',

				/**
				 * Add spinner.
				 *
				 * @param $element
				 */
				add: function( $element ) {
					if ( iconicwp_plugin.helpers.spinner.exists( $element ) ) {
						return;
					}

					$element.after( iconicwp_plugin.helpers.spinner.tpl );
				},

				/**
				 * Remove spinner.
				 *
				 * @param $element
				 */
				remove: function( $element ) {
					$element.next( '.' + iconicwp_plugin.helpers.spinner.class ).remove();
				},

				/**
				 * Spinner exists.
				 *
				 * @param $element
				 * @return {boolean}
				 */
				exists: function( $element ) {
					var $spinner = $element.next( '.' + iconicwp_plugin.helpers.spinner.class );

					return $spinner.length > 0;
				}
			}
		},

		/**
		 * Setup support form.
		 */
		support_form: {
			/**
			 * Set up cache with common elements and vars.
			 */
			cache: function() {
				iconicwp_plugin.support_form.els = {
					'docs_search_field': $( '.iconic-helpscout-search input' ),
					'show_after_search': $( '.iconic-js-show-after-docs-search' ),
					'reviewed_info_link': $( '.iconic-js-reviewed-info' ),
					'docs_results_container': $( '.iconic-support-results__results' ),
					'docs_no_results_container': $( '.iconic-support-results__no-results' ),
					'docs_no_docs_container': $( '.iconic-support-results__no-docs' ),
					'docs_resources_container': $( '.iconic-support-results__resources' ),
					'faq_content_container': $( '.iconic-js-faq-content' ),
					'which_plugin_select': $( '.iconic-which-plugin select' ),
					'support_type_select': $( '.iconic-support-type input' ),
					'faq_dropdown': $( '.iconic-faq-dropdown select' ),
					'faq_result': $( '.iconic-faq-result' ),
					'faq_proceed': $( '.iconic-faq-proceed' ),
					'support_proceed': $( '.iconic-support-proceed' )
				};

				iconicwp_plugin.support_form.vars = {
					'search_id': 0,
					'search_attempt': 0,
					'field_notice_class': 'iconic-support-notice',
					'show_after_search_class': 'iconic-js-show-after-docs-search',
					'current_collection_id': ''
				};
			},

			/**
			 * Init support form.
			 */
			init: function() {
				iconicwp_plugin.support_form.cache();
				iconicwp_plugin.support_form.setup_form_submission();
				iconicwp_plugin.support_form.setup_docs_search();
				iconicwp_plugin.support_form.setup_support_type_select();
				iconicwp_plugin.support_form.setup_plugin_select();
				iconicwp_plugin.support_form.setup_faq_select();
			},

			/**
			 * Prevent enter to submit.
			 */
			setup_form_submission: function() {
				$( document ).on( 'keypress', '.gform_wrapper', function( e ) {
					var code = e.keyCode || e.which;
					if ( code === 13 && ! $( e.target ).is( 'textarea,input[type="submit"],input[type="button"]' ) ) {
						e.preventDefault();
						return false;
					}
				} );

				iconicwp_plugin.support_form.els.support_proceed.on( 'click', 'label', function() {
					let $form = $( this ).closest( 'form' );

					if ( $form.hasClass( 'gform--submiting' ) ) {
						return;
					}

					$form[ 0 ].submit();
					$form.addClass( 'gform--submiting' )
				} );
			},

			/**
			 * Setup docs search.
			 */
			setup_docs_search: function() {
				if ( iconicwp_plugin.support_form.els.docs_search_field.length <= 0 ) {
					return;
				}

				iconicwp_plugin.support_form.els.docs_search_field.attr( 'autocomplete', 'off' );

				iconicwp_plugin.support_form.els.docs_search_field.keyup( function( e ) {
					iconicwp_plugin.support_form.vars.search_attempt ++;

					var $input = $( this ),
						query = $input.val(),
						$li = $input.closest( '.gfield' );

					$( '.' + iconicwp_plugin.support_form.vars.field_notice_class ).remove();

					if ( query.length <= 0 || query.length < 3 ) {
						iconicwp_plugin.support_form.hide_results();
					}

					if ( query.length <= 0 ) {
						$li.append( '<p class="' + iconicwp_plugin.support_form.vars.field_notice_class + '">Please enter a search term.</p>' );
						return;
					}

					if ( query.length < 3 ) {
						$li.append( '<p class="' + iconicwp_plugin.support_form.vars.field_notice_class + '">Search must be at least 3 characters.</p>' );
						return;
					}

					iconicwp_plugin.support_form.vars.search_id = iconicwp_plugin.support_form.vars.search_attempt;
					iconicwp_plugin.helpers.spinner.remove( $input );

					iconicwp_plugin.helpers.delay.wait( function() {
						if ( iconicwp_plugin.support_form.vars.search_id !== iconicwp_plugin.support_form.vars.search_attempt ) {
							return;
						}

						iconicwp_plugin.helpers.spinner.add( $input );

						iconicwp_plugin.support_form.uncheck_reviewed_info();
						iconicwp_plugin.support_form.hide_results();

						iconicwp_plugin.support_form.search_docs( query, iconicwp_plugin.support_form.vars.current_collection_id, iconicwp_plugin.support_form.vars.search_attempt, function( response, search_attempt ) {
							if ( search_attempt !== iconicwp_plugin.support_form.vars.search_id ) {
								return;
							}

							iconicwp_plugin.support_form.populate_results( response, $li );
							iconicwp_plugin.support_form.els.show_after_search.show();
							iconicwp_plugin.support_form.els.reviewed_info_link.show();

							iconicwp_plugin.helpers.spinner.remove( $input );
						} );
					}, 1000 );
				} );
			},

			/**
			 * Populate results.
			 *
			 * @param response
			 */
			populate_results: function( response, $search_field_li ) {
				var article_count = response.length;

				iconicwp_plugin.support_form.hide_results();

				if ( article_count <= 0 ) {
					iconicwp_plugin.support_form.els.docs_no_results_container.show();
					return;
				}

				$search_field_li.append( '<p class="' + iconicwp_plugin.support_form.vars.field_notice_class + '">We found ' + article_count + ' article(s) that may help:</p>' );

				var $list = iconicwp_plugin.helpers.make_link_list( response );

				iconicwp_plugin.support_form.els.docs_results_container.append( $list ).show();
				iconicwp_plugin.support_form.els.docs_resources_container.show();
			},

			/**
			 * Search docs.
			 */
			search_docs: function( query, collection_id, search_attempt, callback ) {
				var docs = [];

				if ( '' === query ) {
					if ( typeof callback === 'function' ) {
						callback( docs, search_attempt );
					}

					return;
				}

				jQuery.get( '/wp-json/wp/v2/knowledgebase?knowledgebase_cat=' + encodeURIComponent( iconicwp_plugin_vars.general_docs_id ) + ',' + encodeURIComponent( collection_id ) + '&search=' + encodeURIComponent( query ), function( results ) {
					if ( results.length > 0 ) {
						jQuery.each( results, function( index, result ) {
							docs.push( {
								text: result.title.rendered,
								url: result.link
							} );
						} );
					}

					if ( typeof callback === 'function' ) {
						callback( docs, search_attempt );
					}
				}).fail(function() {
					if ( typeof callback === 'function' ) {
						callback( docs, search_attempt );
					}
				});
			},

			/**
			 * Setup support type select.
			 */
			setup_support_type_select: function() {
				iconicwp_plugin.support_form.els.support_type_select.on( 'change', function() {
					var $input = $( this ),
						value = 'docs' === $input.val() ? 'docs' : '';

					iconicwp_plugin.support_form.hide_results();
					iconicwp_plugin.support_form.uncheck_reviewed_info();
					iconicwp_plugin.support_form.uncheck_faq_proceed();
					iconicwp_plugin.support_form.els.docs_search_field.val( '' );
					iconicwp_plugin.support_form.set_collection_ids( value );
				} );
			},

			/**
			 * Set collection IDs.
			 *
			 * @param value
			 */
			set_collection_ids: function( value ) {
				var support_type = iconicwp_plugin.support_form.els.support_type_select.filter( ':checked' ).val();

				if ( 'docs' === value || 'docs' === support_type ) {
					iconicwp_plugin.support_form.vars.current_collection_id = $( '.general-docs-ids input' ).val();
					return;
				}

				iconicwp_plugin.support_form.vars.current_collection_id = value;
			},

			/**
			 * Setup plugin select.
			 */
			setup_plugin_select: function() {
				iconicwp_plugin.support_form.els.which_plugin_select.on( 'change', function() {
					var $select = $( this ),
						value = $select.val();

					iconicwp_plugin.support_form.set_collection_ids( value );
					iconicwp_plugin.support_form.hide_results();
					iconicwp_plugin.support_form.uncheck_reviewed_info();

					if ( value === '0' ) {
						iconicwp_plugin.support_form.els.docs_no_docs_container.show();
						iconicwp_plugin.support_form.els.show_after_search.show();
					}
				} );
			},

			/**
			 * Setup FAQ select.
			 */
			setup_faq_select: function() {
				iconicwp_plugin.support_form.els.faq_dropdown.on( 'change', function() {
					var $select = $( this ),
						value = $select.val();

					iconicwp_plugin.support_form.els.faq_proceed.hide();
					iconicwp_plugin.support_form.els.faq_content_container.html( '' );
					iconicwp_plugin.support_form.els.faq_result.hide();

					if ( value === '' ) {
						return;
					}

					var id = parseInt( value );

					if ( isNaN( id ) ) {
						iconicwp_plugin.support_form.els.faq_proceed.show();
						return;
					}

					iconicwp_plugin.helpers.spinner.add( $select );

					iconicwp_plugin.support_form.get_faq( id, function( response ) {
						iconicwp_plugin.helpers.spinner.remove( $select );

						if ( ! response.success ) {
							return;
						}

						iconicwp_plugin.support_form.els.faq_content_container.html(
							'<h2>' + response.data.question + '</h2>' + response.data.answer
						);
						iconicwp_plugin.support_form.els.faq_result.show();
						iconicwp_plugin.support_form.els.faq_proceed.show();
					} );
				} );
			},

			/**
			 * Get FAQ.
			 */
			get_faq: function( id, callback ) {
				var data = {
					'action': 'iconic_get_faq',
					'id': id
				};

				$.post( iconicwp_plugin_vars.ajax_url, data, function( response ) {
					if ( typeof callback === 'function' ) {
						callback( response );
					}
				} );
			},

			/**
			 * hide results.
			 */
			hide_results: function() {
				iconicwp_plugin.support_form.els.docs_results_container.hide().html( '' );
				iconicwp_plugin.support_form.els.docs_no_results_container.hide();
				iconicwp_plugin.support_form.els.docs_resources_container.hide();
				iconicwp_plugin.support_form.els.docs_no_docs_container.hide();
				iconicwp_plugin.support_form.els.reviewed_info_link.hide();
				iconicwp_plugin.support_form.els.show_after_search.hide();
				$( '.' + iconicwp_plugin.support_form.vars.field_notice_class ).remove();
				iconicwp_plugin.support_form.els.faq_proceed.hide();
			},

			/**
			 * Uncheck reviewed info checkbox.
			 */
			uncheck_reviewed_info: function() {
				iconicwp_plugin.support_form.els.reviewed_info_link.find( 'input:checked' ).siblings( 'label' ).click();
			},

			/**
			 * Uncheck FAQ proceed checkbox.
			 */
			uncheck_faq_proceed: function() {
				iconicwp_plugin.support_form.els.faq_proceed.find( 'input:checked' ).siblings( 'label' ).click();
			}
		}
	};

	$( document ).ready( iconicwp_plugin.on_ready );
}( jQuery, document ));